import { useQuery } from "@tanstack/react-query";
import { PresignedUrls } from "~/api/model";

/**
 * Hook to fetch presigned URLs for a page
 * Similar to useGetUrls in docViewer but simplified for duplicate detection modal
 */
export const useGetPageUrls = (
  pageId: string,
  sectionPageId: string,
  populatePageFn: (
    pageId: string,
    sectionPageId: string
  ) => Promise<PresignedUrls>,
  enabled: boolean
) => {
  return useQuery<PresignedUrls>({
    queryKey: ["pageUrls", pageId],
    queryFn: () => populatePageFn(pageId, sectionPageId),
    staleTime: 12 * 60 * 1000, // 12 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled,
  });
};
